"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryValidations = getCountryValidations;
const regex_1 = require("../regex");
const iban_1 = require("./iban");
const patterns_1 = require("./patterns");
const defaultValidations = {
    phoneNumber: {
        name: "Phone Number",
        transform: (s) => s === null || s === void 0 ? void 0 : s.replace(/[^0-9+]/g, ""),
        validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(/^[0-9+]+$/)),
    },
    postcode: {
        name: "ZIP/Postal Code",
        transform: (s) => s,
        validate: () => true,
    },
    niNumber: {
        name: "SSN/NI Number",
        transform: (s) => s,
        validate: () => true,
    },
    sortCode: {
        name: "Bank Account BIC",
        transform: (s) => s,
        validate: () => true,
    },
    accountNumber: {
        name: "Bank Account IBAN",
        transform: (s) => s,
        validate: () => true,
    },
};
const countryValidations = {
    GB: {
        phoneNumber: {
            name: "Phone Number",
            transform: (s) => s === null || s === void 0 ? void 0 : s.replace(/[^0-9+]/g, ""),
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.GB_PHONE_NUMBER)),
        },
        postcode: {
            name: "Postcode",
            transform: (s) => {
                const clean = s === null || s === void 0 ? void 0 : s.toUpperCase().replace(/[^0-9A-Z ]/g, "").replace(/ +/g, " ");
                const match = clean === null || clean === void 0 ? void 0 : clean.match(patterns_1.GB_POSTCODE);
                return match ? match.slice(1).join(" ") : clean;
            },
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.GB_POSTCODE)),
        },
        niNumber: {
            name: "NI Number",
            transform: (s) => { var _a; return (_a = s === null || s === void 0 ? void 0 : s.toUpperCase()) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9A-Z]/g, ""); },
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.GB_NI)),
        },
        sortCode: {
            name: "Sort Code",
            transform: (s) => s === null || s === void 0 ? void 0 : s.replace(/\D/g, ""),
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.GB_SORT_CODE)),
        },
        accountNumber: {
            name: "Account Number",
            transform: (s) => s === null || s === void 0 ? void 0 : s.replace(/\D/g, ""),
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.GB_ACCOUNT_NUMBER)),
        },
    },
    IE: {
        phoneNumber: {
            name: "Phone Number",
            transform: (s) => s === null || s === void 0 ? void 0 : s.replace(/[^0-9+]/g, ""),
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.IE_PHONE_NUMBER)),
        },
        postcode: {
            name: "Eircode",
            transform: (s) => {
                const clean = s === null || s === void 0 ? void 0 : s.toUpperCase().replace(/[^0-9A-Z ]/g, "").replace(/ +/g, " ");
                const match = clean === null || clean === void 0 ? void 0 : clean.match(patterns_1.IE_EIRCODE);
                return match ? match.slice(1).join(" ") : clean;
            },
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.IE_EIRCODE)),
        },
        niNumber: {
            name: "PPS Number",
            transform: (s) => { var _a; return (_a = s === null || s === void 0 ? void 0 : s.toUpperCase()) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9A-Z/]/g, ""); },
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.IE_PPS)),
        },
        sortCode: {
            name: "Sort Code or BIC",
            transform: (s) => { var _a; return (_a = s === null || s === void 0 ? void 0 : s.toUpperCase()) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9A-Z]/g, ""); },
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.IE_SORT_CODE)) || !!(s === null || s === void 0 ? void 0 : s.match(regex_1.BIC)),
        },
        accountNumber: {
            name: "Account Number or IBAN",
            transform: (s) => { var _a; return (_a = s === null || s === void 0 ? void 0 : s.toUpperCase()) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9A-Z]/g, ""); },
            validate: (s) => !!(s === null || s === void 0 ? void 0 : s.match(patterns_1.IE_ACCOUNT_NUMBER)) || (s !== null && s !== undefined && (0, iban_1.isValidIBAN)(s)),
        },
    },
};
function getCountryValidations(code) {
    if (code !== null && code !== undefined) {
        let cc = code.toUpperCase();
        if (cc === "GG" || cc == "IM" || cc === "JE")
            cc = "GB";
        if (countryValidations[cc] !== undefined) {
            return countryValidations[cc];
        }
    }
    return defaultValidations;
}
